const translations = {
    'overlay.hexCount': 'liczba pól: %d',
    'overlay.instructions': 'Przeciągnij aby przesunąć • Kółko aby przybliżyć • Kliknij heks',
    'overlay.none': '-',
    'overlay.selected': 'zaznaczone: %s',
    'overlay.speed1': '1×',
    'overlay.speed10': '10×',
    'overlay.speed2': '2×',
    'overlay.speed5': '5×',
    'overlay.start': '▶',
    'overlay.stop': '⏹',
    'overlay.zoom': 'przybliżenie: %.2f',
    'overlay.noticeTitle': 'Powiadomienia',
    'overlay.noticeDismiss': 'Zamknij',
    'overlay.noticeFounding': 'Zakładanie osady → %s',
    'overlay.noticeFoundingDone': 'Osada gotowa → %s',
    'overlay.noticeFoundingFailed': 'Założenie osady nieudane → %s',
    'overlay.noticeFoundingFailedDetail': 'Pokonani przez %s.',
    'overlay.noticeFoundingFailedUnknown': 'nieznany wróg',
    'overlay.noticeTransport': 'Transport → %s',
    'overlay.noticeTransportArrived': 'Transport dotarł → %s',
    'overlay.noticeScouting': 'Zwiad → %s',
    'overlay.noticeScoutingDetails': 'Podgląd zwiadu',
    'overlay.noticeScoutingReturn': 'Zwiad wraca → %s',
    'overlay.noticeScoutingDone': 'Zwiad wrócił → %s',
    'overlay.noticeBattle': 'Bitwa → %s',
    'overlay.noticeBattleDone': 'Bitwa zakończona → %s',
    'overlay.noticeBattleDetails': 'Zobacz szczegóły',
    'overlay.noticeBattleReport': 'Raport z bitwy → %s',
    'overlay.noticeBattleReportDetail': '%s • Straty %d/%d',
    'overlay.noticeAwaitingOrders': 'Czeka na rozkazy',
    'overlay.alertTitle': 'Alerty',
    'overlay.alertNotControlled': 'Nie można założyć osady: region niekontrolowany.',
    'overlay.alertInProgress': 'Zakładanie osady już trwa dla tego regionu.',
    'overlay.alertNoPopulation': 'Nie można założyć osady: brak wolnej populacji.',
    'overlay.alertNotEnoughResources': 'Nie można założyć osady: brakuje %s.',
    'overlay.alertBuildFailed': 'Nie można zbudować %s: %s.',
    'overlay.alertReasonSlots': 'brak wolnych miejsc na budynki',
    'overlay.alertReasonResources': 'brakuje %s',
    'overlay.alertReasonFish': 'wymaga pobliskich ryb',
    'overlay.alertReasonGold': 'wymaga złóż złota w regionie',
    'overlay.alertReasonIron': 'wymaga złóż żelaza w regionie',
    'overlay.alertColdWarning': '%s: zadłużenie zimna %d%%',
    'overlay.alertStarvationWarning': '%s: zapas jedzenia %.1f godz.',
    'overlay.alertDeaths': '%d osób zmarło w %s (%s)',
    'overlay.alertCauseStarvation': 'głód',
    'overlay.alertCauseCold': 'zimno',
};

export default translations;
